'use client';

import { Box, Typography } from '@mui/material';

export const TradingSection = () => (
  <Box>
    <Typography variant="body1" color="text.secondary">
      This section is coming soon.
    </Typography>
  </Box>
);
